import React from 'react';
import classNames from 'classnames';

const Button = ({ show, ...props }) => {
  return (
    <button
      className="Listview__Card__quickInfoButton"
      type="button"
      {...props}
    >
      Quick Info{' '}
      <i
        className={classNames({
          'icon-generalcaretdownmedium': !show,
          'icon-generalcaretupmedium': show,
        })}
      />
    </button>
  );
};

export default Button;
